import dayjs from "dayjs";

/** 시작 날짜 선택시 최대 조회 기간으로 끝 날자 값 자동 세팅 함수
 * @param e - 이벤트 객체
 * @param setSearchData - 상태변경 함수
 * @param setDay - 날짜 차이
 */
export const startDateHandler = (
  e: any,
  setSearchData: (key: string, value: any) => void,
  setDay: number
) => {
  const selectedDate = new Date(e.target.value);
  selectedDate.setDate(selectedDate.getDate() + setDay);

  setSearchData("startDate", e.target.value);
  setSearchData("endDate", selectedDate.toISOString().split("T")[0]);
};

export const startDateHourHandler = (
  e: any,
  setSearchData: (key: string, value: any) => void,
  setDay: number
) => {
  const selectedDate = new Date(e.target.value);
  selectedDate.setDate(selectedDate.getDate() + setDay);

  setSearchData("startDate", e.target.value);
  setSearchData(
    "endDate",
    dayjs(selectedDate.toISOString()).format("YYYY-MM-DD HH:mm:ss")
  );
};
